export default "__VITE_ASSET__Dc22i1ya__"